export default __webpack_public_path__ + "static/media/times.2be3e756.svg";